module.exports = __webpack_public_path__ + "static/media/arrival-icon.f719f189.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/suttonparkbus/arrival-icon.svg
// module id = 866
// module chunks = 0